<template>
  <v-data-table fixed-header disable-pagination hide-default-footer :headers="headers" :items="items" no-data-text="Sem dados">
    <template v-slot:[`item._id`]="{ item }">
      <span>{{ item._id }}</span>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      {{ item.name }}
    </template>
    <template v-slot:[`item.activated_clients`]="{ item }">
      {{ item.activated_clients }}
    </template>
    <template v-slot:[`item.clients`]="{ item }">
      {{ item.clients | abreviation({ isInteger: true }) }}
    </template>
    <template v-slot:[`item.tickets`]="{ item }">
      {{ item.tickets | abreviation({ isInteger: true }) }}
    </template>
    <template v-slot:[`item.quantity`]="{ item }">
      {{ locale(item.quantity, 2) | localeString(0, 2) }}
    </template>
    <template v-slot:[`item.revenue`]="{ item }">
      <span>{{ locale(item.revenue, 2) | localeString(2) | currency }}</span>
    </template>
    <template v-slot:[`item.discounts`]="{ item }">
      <div v-if="!isPointsCurrentOfferType">
        {{ locale(item.discounts, 2) | localeString(2) | currency }}
      </div>

      <div v-else>
        {{ item.discounts | localeString(0) | abreviation({ isInteger: true }) }}
      </div>
    </template>
    <template v-slot:[`item.offers_schedule_discounts`]="{ item }">
      {{ locale(item.offers_schedule_discounts, 2) | localeString(2) | currency }}
    </template>
    <template v-slot:[`item.impact`]="{ item }">
      {{ locale(item.impact, 2) | localeString(2) | percent }}
    </template>
  </v-data-table>
</template>

<script>
import { abbreviation, localeString } from '@/config/helpers.js'
export default {
  name: 'ProductsResultsTable',
  props: {
    metrics: {
      type: Object,
      default: () => {},
    },
    currentOfferTypeKeyName: {
      type: String,
      default: '',
    },
    campaignModel: {
      type: String,
      default: 'sales',
    },
  },
  data: () => ({
    locale: localeString,
    offerSalesKeyNames: {
      offer_sales: 'offer_sales',
      percentage_offer_sales: 'percentage_offer_sales',
      takepay_offer_sales: 'takepay_offer_sales',
      combo_offer_sales: 'combo_offer_sales',
      target_products: 'target_products',
      cashback_percentage_offer_sales: 'cashback_percentage_offer_sales',
      cashback_absolute_offer_sales: 'cashback_absolute_offer_sales',
      points_offer_sales: 'points_offer_sales',
    },
  }),
  computed: {
    isCashbackOrPointsCurrentOfferType() {
      return this.isCashbackCurrentOfferType || this.isPointsCurrentOfferType
    },
    isCashbackCurrentOfferType() {
      return [this.offerSalesKeyNames.cashback_percentage_offer_sales, this.offerSalesKeyNames.cashback_absolute_offer_sales].includes(
        this.currentOfferTypeKeyName
      )
    },
    offerColumnLabel() {
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) return 'Cashback distribuido'
        else return 'Pontos distribuídos'
      }
      return 'Desconto concedido'
    },
    isPointsCurrentOfferType() {
      return this.offerSalesKeyNames.points_offer_sales === this.currentOfferTypeKeyName
    },
    headers() {
      const headers = [
        {
          text: 'Código',
          value: '_id',
          sortable: false,
        },
        {
          text: 'Produto',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Clientes',
          value: 'clients',
          sortable: false,
        },
        {
          text: 'Cupons',
          value: 'tickets',
          sortable: false,
        },
        {
          text: 'Unidades com desconto',
          value: 'quantity',
          sortable: false,
        },
        {
          text: 'Faturamento',
          value: 'revenue',
          sortable: false,
        },
        {
          text: this.offerColumnLabel,
          value: 'discounts',
          sortable: false,
        },
        {
          text: 'Impacto',
          value: 'impact',
          sortable: false,
        },
      ]

      if (!this.isCashbackOrPointsCurrentOfferType) {
        headers.splice(7, 0, {
          text: 'Desconto da gestão',
          value: 'offers_schedule_discounts',
          isActive: true,
          isRequired: false,
          isDefault: true,
        })
      }

      if (this.campaignModel === 'activatable') {
        headers.splice(2, 0, {
          text: 'Clientes que ativaram',
          value: 'activated_clients',
          isActive: true,
          isRequired: false,
          isDefault: true,
        })
      }
      return headers
    },
    items() {
      let discountsLabel = ''
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) discountsLabel = 'cashback'
        else discountsLabel = 'points'
      } else discountsLabel = 'discounts'
      if (!this.metrics?.products_metrics?.table) return []
      const response = this.metrics.products_metrics.table.map((row) => ({
        _id: row.product.sku,
        name: row.product.name,
        quantity: row.sales.quantity,
        activated_clients: row.sales.activated_clients,
        discounts: row.sales[discountsLabel],
        offers_schedule_discounts: row.sales.offers_schedule_discounts,
        revenue: row.sales.revenue,
        tickets: row.sales.tickets,
        clients: this.isBenefitOfferType ? row.earn?.clients : row.sales.clients,
        impact: this.getSafe(() => row.sales.quantity / row.total.quantity) * 100 || 0,
      }))
      return response.length ? response.slice(0, 10) : []
    },
  },
  methods: {
    abbreviation,
    localeString,
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  border-left: 1px solid #eee;
}
::v-deep thead th {
  border-bottom: 1px solid #eee !important;
}

::v-deep .v-data-table-header tr,
::v-deep .v-data-table-header th {
  background: #fff !important;
  border-top: 1px solid #fff !important;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 12px;
    line-height: 1;
    border-left: 1px solid #eee;
  }
}
::v-deep tbody {
  td:first-child {
    border-left: none;
  }
}
::v-deep th:first-child {
  border-left: none;
}
</style>
